module.exports = __webpack_public_path__ + "static/img/3.072fe5c6.png";